var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSquareTag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29 21h38v38H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 22v36H30V22h36m2-2H28v40h40Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m72.3 62.3 1.5-2.1a1 1 0 0 1 1.3-.2l14.3 10.1a1 1 0 0 1 .2 1.3l-1.5 2.1a1 1 0 0 1-1.3.2l-14.3-10a1.06 1.06 0 0 1-.2-1.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3 74.9a2 2 0 0 1-1.1-.3L71.9 64.5a1.93 1.93 0 0 1-.5-2.7l1.5-2.1a1.93 1.93 0 0 1 2.7-.5l14.3 10.1a2 2 0 0 1 .5 2.6L88.9 74a1.92 1.92 0 0 1-1.6.9ZM74.5 60.8 73 62.9 87.3 73l1.5-2Zm14.3 10.1.8.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m76.132 65.865 2.598-3.674 1.551 1.097-2.598 3.674z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 55.7,
    r: 11.6,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 68.2a12.61 12.61 0 0 1-12.6-12.6A12.46 12.46 0 0 1 65 43.1a12.65 12.65 0 0 1 7.3 2.3 12.52 12.52 0 0 1 3 17.5A12.74 12.74 0 0 1 65 68.2ZM65 45a10.6 10.6 0 1 0 10.7 10.5 10.19 10.19 0 0 0-4.6-8.6A11 11 0 0 0 65 45Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1 62.8H55.3l-1.3-4h13.1V44.1l4 1.2v17.5zM48 25.3a3.3 3.3 0 1 0 3.3 3.3 3.33 3.33 0 0 0-3.3-3.3Zm0 5.1a1.8 1.8 0 1 1 1.8-1.8 1.79 1.79 0 0 1-1.8 1.8Z"
  })));
};
export default SvgSquareTag;